<div class="checkbox-container">
  <mat-checkbox [formControl]="formControl" (change)="changeValue($event)" [checked]="initialChecked">
    <app-form-label class="checkbox-label" (click)="changeValue(!formControl.value)">
      {{ label }}
    </app-form-label>
  </mat-checkbox>
</div>
